import { useEffect } from 'react'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'

const baseTitle = getEnvVariableValue(VARIABLES.BASE_TITLE) ?? 'Horizon'

export default function DocumentTitleUpdater({
    routeTitle,
    children,
    baseTitle,
    separator,
}) {
    useEffect(() => {
        document.title = `${baseTitle}${
            routeTitle ? separator : ''
        }${routeTitle}`

        return () => {
            document.title = baseTitle
        }
    }, [routeTitle, baseTitle, separator])

    return children || null
}

DocumentTitleUpdater.defaultProps = {
    routeTitle: '',
    baseTitle: baseTitle,
    separator: ' | ',
}
